// 后端搜索类型，以及结果页类型
export const SEARCH_TYPE = {
    cdr: 'CDR',
    // 从analytics返回
    analytics: 'ANALYTICS',
    motif: 'MOTIF',
    fragmentSize: 'FRAGMENT_SIZE',
    fragmentMulti: 'FRAGMENT_MULTI',
    sequence: 'MANUAL',
    short: 'SHORT',
    antibody: 'ANTIBODY',
    degenerate: 'DEGENERATE',
    modification: 'MODIFICATION',
};
// 前端搜索tab类型
export const SEARCH_TYPES = {
    sequence: 'sequence',
    short: 'short',
    cdr: 'cdr',
    motif: 'motif',
    motif2: 'motif2',
    fragment: 'fragment',
    advanced: 'advanced',
    antibody: 'antibody',
    combined: 'combined',
    degenerate: 'degenerate',
    modification: 'modification',
};
export const SEARCH_TYPE_BE_TO_FE = {
    CDR: 'cdr',
    ANALYTICS: 'sequence',
    MANUAL: 'sequence',
    SHORT: 'short',
    MOTIF: 'motif',
    MOTIF2: 'motif2',
    FRAGMENT_SIZE: 'fragment',
    FRAGMENT_MULTI: 'fragment',
    ANTIBODY: 'antibody',
    COMBINED: 'combined',
    DEGENERATE: 'degenerate',
    MODIFICATION: 'modification',
};
export const SEARCH_TYPE_TO_USER_SETTING_TYPE = {
    sequence: 'BIO_MANUAL_SEARCH',
    short: 'BIO_SHORT_SEARCH',
    cdr: 'BIO_CDR_SEARCH',
    motif: 'BIO_MOTIF_SEARCH',
    advanced: '',
    fragment: 'BIO_FRAGMENT_SEARCH',
    antibody: 'BIO_ANTIBODY_SEARCH',
    degenerate: 'BIO_DEGENERATE_SEARCH',
    modification: 'BIO_MODIFICATION_SEARCH',
};
export const TYPE_PROTEIN = 'protein';
export const TYPE_NUCLEOTIDE = 'nucleotide';
export const ABST_PROTEIN = 'PROTEIN';
export const ABST_NUC = 'NUCLEOTIDE';
export const NUCLEOTIDES_DB = 'NUCLEOTIDE';
export const PROTEIN_DB = 'PROTEIN';
export const CODE_PROTEIN = 1;
export const CODE_NUCLEOTIDE = 0;
export const UNIT_PROTEIN = 'aa';
export const UNIT_NUCLEOTIDE = 'nt';
// sequence types 请使用下方的SEQUENCE_TYPE, 不要再使用这个SEQUENCE_TYPES !!!!!!!!!
export const SEQUENCE_TYPES = [ABST_NUC, ABST_PROTEIN];
// database types
export const DATABASE_TYPES = [NUCLEOTIDES_DB, PROTEIN_DB];
export const MODIFICATION_SEARCH_ALGORITHM_TYPES = {
    Blast: 'Blast',
    NW: 'Nw',
};
export const ScoreMatrixOptions = [
    'BLOSUM30',
    'BLOSUM35',
    'BLOSUM40',
    'BLOSUM45',
    'BLOSUM50',
    'BLOSUM55',
    'BLOSUM62',
    'BLOSUM65',
    'BLOSUM70',
    'BLOSUM75',
    'BLOSUM80',
    'BLOSUM85',
    'BLOSUMN',
    'PAM10',
    'PAM20',
    'PAM30',
    'PAM40',
    'PAM60',
    'PAM70',
    'PAM80',
    'PAM90',
    'PAM100',
    'PAM120',
    'PAM130',
    'PAM140',
    'PAM150',
    'PAM160',
    'PAM170',
    'PAM190',
    'PAM200',
    'PAM210',
    'PAM220',
    'PAM230',
    'PAM250',
    'PAM260',
    'PAM270',
    'PAM280',
    'PAM290',
    'PAM310',
    'PAM320',
    'PAM330',
    'PAM340',
    'PAM350',
    'PAM360',
    'PAM380',
    'PAM390',
    'PAM400',
    'PAM410',
    'PAM420',
    'PAM440',
    'PAM450',
    'PAM460',
    'PAM470',
    'PAM480',
    'PAM490',
    'PAM500',
];
